import React, { FC } from 'react';
import styled from 'styled-components';

interface ChangeBlockProps {
  x: number;
  y: number;
  width: number;
  height: number;
  value: number;
  bgColor: string;
  textColor: string;
}

const Block = styled.rect<{ bgColor: string }>`
  fill: ${({ bgColor }) => bgColor};
  rx: 4px;
  ry: 4px;
`;

const Text = styled.text<{ textColor: string }>`
  fill: ${({ textColor }) => textColor};
  font-size: 10px;
  font-weight: bold;
  text-anchor: middle;
  dominant-baseline: central;
`;

const ChangeBlock: FC<ChangeBlockProps> = ({ x, y, width, height, value, bgColor, textColor }) => {
  const displayValue = value === 0 ? '-' : value > 0 ? `+${value}` : value;
  return (
    <>
      <Block x={x} y={y} width={width} height={height} bgColor={bgColor} />
      <Text x={x + width / 2} y={y + height / 2} textColor={textColor}>
        {displayValue}
      </Text>
    </>
  );
};

export default ChangeBlock;
